import { render, staticRenderFns } from "./DesktopFreebie.vue?vue&type=template&id=4e7a3364"
import script from "./DesktopFreebie.vue?vue&type=script&lang=js"
export * from "./DesktopFreebie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports